import { getAxiosInstance } from "../../../redux/common";

export const getAllCalibrations = async (queryParams) => {
  loginLocally(); //uncomment when using locally
  return await getAxiosInstance().get("/api/calibration/filter", {
    params: queryParams,
  });
};

export const loginLocally = async () => {
  await getAxiosInstance().post("/api/auth/login", {
    username: "test2_calibrator@sh200212.website.pl", // type here calibrator username
    password: "AQ@aaaaaaaa1", // type here calibrator password
  });
};

export const getFliteredCalibrations = async (queryParams) => {
  loginLocally();
  return await getAllCalibrations(queryParams);
};

export const removeCalibrationById = async (deviceId) => {
  return await getAxiosInstance().delete("/api/calibration/" + deviceId);
};

export const getBaseAveragedCalibrations = async () => {
  return await getAxiosInstance().get("/api/calibration/averaged/base");
};

export const getManufacturerAveragedCalibrations = async () => {
  return await getAxiosInstance().get("/api/calibration/averaged/manufacturer");
};

export const getBrandAveragedCalibrations = async () => {
  return await getAxiosInstance().get("/api/calibration/averaged/brand");
};

export const getModelAveragedCalibrations = async () => {
  return await getAxiosInstance().get("/api/calibration/averaged/model");
};

export const getAveragedById = async (id) => {
  return await getAxiosInstance().get("/api/calibration/averaged/" + id);
};

export const includeCheckBox = async (id) => {
  return await getAxiosInstance().post("/api/calibration/averaged/include", {
    id: id,
  });
};

export const excludeCheckBox = async (id) => {
  return await getAxiosInstance().post("/api/calibration/averaged/exclude", {
    id: id,
  });
};

export const removeAveragedCalibrationById = async (id) => {
  return await getAxiosInstance().delete("/api/calibration/averaged/" + id);
};

export const importFileHandler = async (file, params) => {
  const formData = new FormData();
  formData.append("file", file);
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      formData.append(key, params[key]);
    }
  }
  return await getAxiosInstance().post("/api/calibration/import", formData);
};
export const exportFileHandler = async () => {
  return await getAxiosInstance().get("/api/calibration/export");
};
